import CreatorElement from "./creator.element";
import { loadModelInstance, unloadModelInstance, type IAssetModelInstance } from "../loader/loader.modelinstance";

// A GLB model panel: instantiated from a shared (cached) AssetContainer at its
// authored real-world size, animations auto-played. Unlike flat panels, models
// carry a real front/back, so they get NO 180deg Y flip (panelFlip = false).
export default class CreatorGlbElement extends CreatorElement {
  private instanceAsset: IAssetModelInstance = { type: "model", path: "" };

  protected override get panelFlip(): boolean {
    return false;
  }

  public async build(): Promise<void> {
    this.instanceAsset = { type: "model", path: this.file.path, extension: ".glb" };
    await loadModelInstance(this.instanceAsset, this.scene, this.anchor);

    this.applyTransform(); // anchor carries position + rotation + scale.

    for (const group of this.instanceAsset.animationGroups ?? []) group.play(true);
  }

  public override dispose(): void {
    // Tears down this instance's nodes + animation groups, but NOT the shared
    // template's materials (reused by sibling instances; disposed by
    // disposeModelCache).
    unloadModelInstance(this.instanceAsset);
    this.anchor.dispose();
  }
}
